@if (isLoading) {
    <craig-placeholder></craig-placeholder>
} @else {
    <craig-header></craig-header>
    <craig-content [isStreamingEnabled]="isStreamingEnabled"></craig-content>
}
